import {page, queueParamCookies, queueSessionTrackingCookies} from '@commercial-website/analytics'
import {hasAdvertisingConsent, hubspotAPI} from '@commercial-website/consent'
import {pushEvent} from '@commercial-website/observability'
import type {GatsbyBrowser} from 'gatsby'

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({location}) => {
    if (location.search) {
        queueParamCookies(new URLSearchParams(location.search), {
            hasAdvertisingConsent,
            onConsentChange: hubspotAPI.addPrivacyConsentListener,
        })
    }

    queueSessionTrackingCookies({
        hasAdvertisingConsent,
        onConsentChange: hubspotAPI.addPrivacyConsentListener,
    })

    // The page path without the locale segment, e.g. `/pricing` instead of `/en/pricing`
    const rawPath = `/${location.pathname.split('/').slice(2).join('/')}`

    page({
        rawPath,
    })

    pushEvent('navigation', {
        url: location.pathname,
    })
}
